import { AdContentElement } from '@core/models/ad-content-element.model';

export class MultiFieldEditorContent {
	isComplete: boolean;
	contents: AdContentElement[];

	constructor() {
		this.isComplete = false;
		this.contents = [];
	}

	get isEmpty(): boolean {
		return this.contents.length <= 0;
	}

}
